// Template246: Bélgica - Día 1 Bruselas (Page3.jsx)
// Hero Grand Place + sticker + título, intro, bloques Grand Place / Manneken / Galerías con SabiasQue, caja tip, chocolatería.

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

const Template246 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;
	const heroTitle = page?.texts?.[1]?.content;
	const intro = page?.texts?.[2]?.content;
	const block1Title = page?.texts?.[3]?.content;
	const block1Body = page?.texts?.[4]?.content;
	const block2Title = page?.texts?.[6]?.content;
	const block2Body = page?.texts?.[7]?.content;
	const tipBox = page?.texts?.[8]?.content;
	const chocolateriaTip = page?.texts?.[9]?.content;
	const block3Title = page?.texts?.[10]?.content;
	const block3Body = page?.texts?.[11]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const portadaImage = getImageSrc("portada");
	const portadaSticker = getImageSrc("portada-sticker");
	const img1 = getImageSrc("img1");
	const img2 = getImageSrc("img2-sticker");
	const img3 = getImageSrc("img3");
	const chocolateriaImage = getImageSrc("chocolateria");
	const logoImage = getCanvasImageUrl("logo");

	const sabiasQue = Array.isArray(page?.data?.sabiasQue)
		? page.data.sabiasQue
		: [];
	const comoLlegar = page?.data?.comoLlegar; // opcional, ej. no usado en Bélgica
	const actualHeaderColor = headerBackgroundColor || "#D4A017";

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		marginBottom: "4px",
		marginTop: "8px",
	};

	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			{/* Cabecera */}
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 9999,
				}}
			>
				{headerText}
				{logoImage && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: isSmallScreen ? 66 : 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			{/* Hero */}
			{portadaImage && (
				<Box data-block-id="image-0" sx={{ position: "relative" }}>
					<Box
						component="img"
						src={portadaImage}
						alt=""
						sx={{ width: "100%", height: 200, objectFit: "cover" }}
					/>
					{portadaSticker && (
						<Box
							component="img"
							src={portadaSticker}
							alt=""
							sx={{
								width: 100,
								position: "absolute",
								bottom: 55,
								left: 21,
							}}
						/>
					)}
					{heroTitle && (
						<Box
							component="h1"
							sx={{
								fontSize: 32,
								textAlign: "center",
								position: "absolute",
								bottom: 0,
								margin: 1.25,
								left: 20,
								color: "#fff",
								textShadow: "2px 2px 4px rgba(0,0,0,0.6)",
							}}
						>
							{heroTitle}
						</Box>
					)}
				</Box>
			)}

			<Box data-block-id="text-1" sx={{ padding: "10px 12px" }}>
				{intro && (
					<Box
						component="p"
						sx={{
							fontSize: 13,
							color: "#333",
							margin: 0,
							padding: 0,
							marginTop: "-8px",
						}}
					>
						{intro}
					</Box>
				)}

				<Box
					data-block-id="text-2"
					sx={{
						display: "flex",
						flexDirection: "column",
						gap: 1.5,
						marginTop: 1.5,
						position: "relative",
					}}
				>
					{/* Block 1: Grand Place */}
					<Box
						data-block-id="text-3"
						sx={{
							display: "flex",
							flexDirection: "column",
							gap: 2,
							position: "relative",
						}}
					>
						<Box sx={{ display: "flex", gap: 2.5, alignItems: "flex-start" }}>
							{sabiasQue[0] && (
								<Box sx={{ position: "absolute", top: 0, left: "33%" }}>
									<SabiasQue
										icono={sabiasQue[0].icono}
										texto={sabiasQue[0].texto}
									/>
								</Box>
							)}
							{sabiasQue[1] && (
								<Box sx={{ position: "absolute", top: 40, left: "33%" }}>
									<SabiasQue
										icono={sabiasQue[1].icono}
										texto={sabiasQue[1].texto}
									/>
								</Box>
							)}
							{img1 && (
								<Box
									component="img"
									src={img1}
									alt=""
									sx={{
										width: "40%",
										height: 110,
										borderRadius: "12px",
										objectFit: "cover",
									}}
								/>
							)}
							<Box sx={{ width: "60%", position: "relative" }}>
								{block1Title && (
									<Box component="h3" sx={estiloH3}>
										{block1Title}
									</Box>
								)}
								{block1Body && (
									<Box component="p" sx={estiloP}>
										{block1Body}
									</Box>
								)}
							</Box>
						</Box>
					</Box>

					{/* Block 2: Manneken Pis */}
					<Box
						data-block-id="text-4"
						sx={{
							display: "flex",
							flexDirection: "column",
							gap: 2,
							position: "relative",
						}}
					>
						<Box sx={{ display: "flex", gap: 2.5, alignItems: "flex-start" }}>
							{sabiasQue[2] && (
								<Box sx={{ position: "absolute", top: 0, left: "33%" }}>
									<SabiasQue
										icono={sabiasQue[2].icono}
										texto={sabiasQue[2].texto}
									/>
								</Box>
							)}
							{img2 && (
								<Box
									component="img"
									src={img2}
									alt=""
									sx={{
										width: "40%",
										height: 110,
										borderRadius: "12px",
										objectFit: "cover",
									}}
								/>
							)}
							<Box sx={{ width: "60%", position: "relative" }}>
								{block2Title && (
									<Box component="h3" sx={estiloH3}>
										{block2Title}
									</Box>
								)}
								{block2Body && (
									<Box component="p" sx={estiloP}>
										{block2Body}
									</Box>
								)}
							</Box>
						</Box>
					</Box>

					{/* Tip box */}
					{tipBox && (
						<Box
							data-block-id="text-5"
							sx={{
								backgroundColor: "#f9ebc8",
								border: "2px solid #D4A017",
								borderRadius: "12px",
								padding: "8px 14px",
								fontSize: "12px",
								color: "#444",
								textAlign: "center",
							}}
						>
							{tipBox}
						</Box>
					)}

					{/* Block 3: Galerías + chocolatería */}
					<Box
						data-block-id="text-6"
						sx={{
							display: "flex",
							flexDirection: "column",
							gap: 2,
							position: "relative",
						}}
					>
						{chocolateriaImage && (
							<Box
								component="img"
								src={chocolateriaImage}
								alt=""
								sx={{
									width: 100,
									position: "absolute",
									bottom: isSmallScreen ? -100 : -20,
									left: -30,
								}}
							/>
						)}
						{chocolateriaTip && (
							<Box
								sx={{
									position: "absolute",
									bottom: isSmallScreen ? -80 : 40,
									left: isSmallScreen ? 60 : 0,
									backgroundColor: "#fff8db",
									border: "2px solid #D4A017",
									borderRadius: "16px 16px 16px 0px",
									padding: "10px 12px",
									fontSize: 11,
									color: "#444",
									boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
									maxWidth: isSmallScreen ? 220 : 120,
								}}
								dangerouslySetInnerHTML={{ __html: chocolateriaTip }}
							/>
						)}
						<Box sx={{ display: "flex", gap: 2.5, alignItems: "flex-start" }}>
							{sabiasQue[3] && (
								<Box
									sx={{
										position: "absolute",
										bottom: isSmallScreen ? -30 : -10,
										right: "33%",
									}}
								>
									<SabiasQue
										icono={sabiasQue[3].icono}
										texto={sabiasQue[3].texto}
									/>
								</Box>
							)}
							{img3 && (
								<Box
									component="img"
									src={img3}
									alt=""
									sx={{
										width: "40%",
										height: 110,
										borderRadius: "12px",
										objectFit: "cover",
									}}
								/>
							)}
							<Box sx={{ width: "60%", position: "relative" }}>
								{block3Title && (
									<Box component="h3" sx={estiloH3}>
										{block3Title}
									</Box>
								)}
								{block3Body && (
									<Box component="p" sx={estiloP}>
										{block3Body}
									</Box>
								)}
							</Box>
						</Box>
					</Box>
				</Box>
				{/* Cómo llegar (opcional, no usado en Bélgica) */}
				{comoLlegar && (
					<Box
						data-block-id="text-7"
						sx={{
							backgroundColor: "#fde1e0",
							border: "3px solid",
							borderColor: actualHeaderColor,
							borderRadius: "12px",
							padding: "8px 20px",
							fontSize: 13,
							color: "#333",
							marginBottom: isSmallScreen ? 1.5 : 0,
						}}
					>
						<Box
							component="h4"
							sx={{
								margin: 0,
								marginBottom: 1,
								fontSize: 13,
								fontWeight: 700,
								color: actualHeaderColor,
								textTransform: "uppercase",
							}}
						>
							Cómo llegar
						</Box>
						<Box
							sx={{ paddingLeft: 2.5, margin: 0, lineHeight: 1.5 }}
							dangerouslySetInnerHTML={{ __html: comoLlegar }}
						/>
					</Box>
				)}
			</Box>
		</Box>
	);
};

Template246.thumbnail = "/images/template-1.png";
export default Template246;
